export interface GetUserNewExpirationDateRequest {
  userType: string
  expirationDate: string
  _create: boolean
}

export function GetUserNewExpirationDateRequestToJSON(
  value: GetUserNewExpirationDateRequest
): any {
  return {
    user_type: value.userType !== '' ? value.userType : undefined,
    expiration_date:
      value.expirationDate !== '' ? value.expirationDate : undefined,
    _create: value._create ?? undefined
  }
}
